import request from '@/utils/request'

// 订单号查询订单重定向
export function login() {
    return request({
        url: '/api/category',
        method: 'get'
    })
}

//获取产品分类
export function getProductClassifies() {
    return request({
        url: '/api/public/product-classifies',
        method: 'get',
    })
}

// 获取产品列表
export function getProducts(data) {
    return request({
        url: '/api/public/products',
        method: 'get',
        params: data
    })
}

// 获取产品展示
export function getProductDisplays() {
    return request({
        url: '/api/public/product-displays',
        method: 'get',
    })
}
//获取产品服务
export function getProductServices() {
    return request({
        url: '/api/public/product-services',
        method: 'get',
    })
}
// 获取行业应用
export function getIndustryApplications() {
    return request({
        url: '/api/public/industry-applications',
        method: 'get',
    })
}

// 新闻
export function getNews() {
    return request({
        url: '/api/public/news',
        method: 'get',
    })
}

// 获取优势列表
export function getAdvantages() {
    return request({
        url: '/api/public/advantages',
        method: 'get',
    })
}

//配置信息
export function getConfigs() {
    return request({
        url: '/api/public/configs',
        method: 'get',
    })
}

// 获取经典案例
export function getClassicCases() {
    return request({
        url: '/api/public/classic-cases',
        method: 'get',
    })
}

// 获取典型应用
export function getTypicalApplications() {
    return request({
        url: '/api/public/typical-applications',
        method: 'get',
    })
}

// 获取所有数据
export function getAllData() {
    return request({
        url: '/api/public/all-data',
        method: 'get',
    })
}
